export enum ProductViewEnum {
  TILE_VIEW,
  LIST_VIEW,
}
